import React from "react"
import { Container, Row } from "react-bootstrap";
import 'animate.css';
import { useMediaQuery } from 'react-responsive';
import ProjectTabsWeb from "../components/ProjectTabsWeb";
import "../styles/project.css";
import "aos/dist/aos.css";
import "animate.css";

import { allProjects, professionalProjects, personalProjects, sideProjects } from 'src/projects/ProjectLists';
import { Banner } from "src/components/Banner";
import { ProjectType } from "src/components/ProjectType";

export interface ProjectInterface {
  title: string;
  summary: string;
  description: string;
  descriptionTitle: string;
  year: string;
  tags: string[];
  url: string;
  projectType: ProjectType;
  imageSrc: string;
  hasVideo: boolean;
  startVideoTime: number;
  videoSrc: string;
  isCoverType: boolean;
  haveTags: boolean;
  people?: number;
  roles?: string[];
  studio?: string[];
  technologies?: string[];
  platforms?: string[];
  collaborators?: string[];
  highlightColor?: string;
  linkData: Array<{ type: 'text' | 'itchio' | 'github'; url: string; overrideUrl?: string; text?: string }>;
  isCheckMoreProjects?: boolean;
  relatedProjects?: string[];
}

export const Projects = () => {
  const isMobile = useMediaQuery({ maxWidth: 767 });

  return (
    <>
      <Banner />

      <section className="project" id="projects">
        <Container className="project-container">
          <Row className={isMobile ? "project-mobile" : ""}>
            <Row size={12} className="d-flex justify-content-center no-padding">
              {/* <h2>Projects</h2>
              <p>Dive into my game development journey: personal highlights, professional projects I've worked on, and some side quests I've done.</p> */}
              <ProjectTabsWeb all={allProjects} prof={professionalProjects} perso={personalProjects} side={sideProjects} />
              {/* {isMobile && <ProjectTabsMobile all={allProjects} prof={professionalProjects} perso={personalProjects} side={sideProjects} />} */}
            </Row>
          </Row>
        </Container>
        {/* <img className="background-image-right" src={colorSharp2}></img> */}
      </section>
    </>
  )
}